import * as React from 'react'
import * as S from './Chip.styles'
import type { ChipProps } from './Chip.types'

const Chip: React.FC<ChipProps> = ({ children, href, type = 'primary' }) => {
  return (
    <S.Container type={type} href={href}>
      {children}
    </S.Container>
  )
}

export default Chip
